import React from "react";
import _ from "lodash";
import numeral from "numeral";
import Checkbox from "components/common/Checkbox";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

const TABS = {
  DEVICE: "device",
  BROWSER: "browser",
  OS: "operating_system_category",
  COUNTRY: "country",
};

const baseButton =
  "rounded px-4 py-1 font-semibold text-gray-700 bg-gray-300 border border-gray-400 hover:bg-gray-200 hover:text-gray-800";

const selectedButton =
  "rounded px-4 py-1 font-semibold text-blue-800 bg-blue-200";

class GeneralRequestView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabsObj: {},
      hideUmObj: {},

      isHideUm: true,
      selectedTab: TABS.DEVICE,

      expression: "",
      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;

    const tempColumns = [
      columns[0],
      columns[1],
      "",
      "b_request",
      "o_request",
      "um_request",
      "total_request",
    ];

    const tempHideUmColumns = [
      ...tempColumns.slice(0, 5),
      ...tempColumns.slice(6),
    ];

    const tempArrangeCol = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "",
        label: "",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "total_request",
        label: "total req #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_request",
        label: "req #",
        group: "b",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_request_percent",
        label: "req %",
        group: "b",
        parsefunc: ({ b_request, total_request }) => {
          return total_request === 0 || b_request === "-"
            ? 0
            : b_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_request",
        label: "req #",
        group: "o",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_request_percent",
        label: "req %",
        group: "o",
        parsefunc: ({ total_request, o_request }) => {
          return total_request === 0 || o_request === "-"
            ? 0
            : o_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "um_request",
        label: "req #",
        group: "um",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "um_request_percent",
        label: "req %",
        group: "um",
        parsefunc: ({ total_request, um_request }) => {
          return total_request === 0 || um_request === "-"
            ? 0
            : um_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];
    const tempHideUmArrangeCol = tempArrangeCol.slice(0, 8);

    const tempTags = tempArrangeCol.slice(3).map((item) => ({
      value: item.key,
      label: item.label,
      group: item.group,
    }));
    const tempHideUmTags = tempHideUmArrangeCol.slice(3).map((item) => ({
      value: item.key,
      label: item.label,
      group: item.group,
    }));

    const tabsObj = {
      [TABS.DEVICE]: {
        records: [],
        columns: _.cloneDeep(tempColumns),
        arrangeColumns: _.cloneDeep(tempArrangeCol),
        tags: tempTags,
      },
      [TABS.BROWSER]: {
        records: [],
        columns: _.cloneDeep(tempColumns),
        arrangeColumns: _.cloneDeep(tempArrangeCol),
        tags: tempTags,
      },
      [TABS.OS]: {
        records: [],
        columns: _.cloneDeep(tempColumns),
        arrangeColumns: _.cloneDeep(tempArrangeCol),
        tags: tempTags,
      },
      [TABS.COUNTRY]: {
        records: [],
        columns: _.cloneDeep(tempColumns),
        arrangeColumns: _.cloneDeep(tempArrangeCol),
        tags: tempTags,
      },
    };

    const hideUmObj = {
      [TABS.DEVICE]: {
        records: [],
        columns: _.cloneDeep(tempHideUmColumns),
        arrangeColumns: _.cloneDeep(tempHideUmArrangeCol),
        tags: tempHideUmTags,
      },
      [TABS.BROWSER]: {
        records: [],
        columns: _.cloneDeep(tempHideUmColumns),
        arrangeColumns: _.cloneDeep(tempHideUmArrangeCol),
        tags: tempHideUmTags,
      },
      [TABS.OS]: {
        records: [],
        columns: _.cloneDeep(tempHideUmColumns),
        arrangeColumns: _.cloneDeep(tempHideUmArrangeCol),
        tags: tempHideUmTags,
      },
      [TABS.COUNTRY]: {
        records: [],
        columns: _.cloneDeep(tempHideUmColumns),
        arrangeColumns: _.cloneDeep(tempHideUmArrangeCol),
        tags: tempHideUmTags,
      },
    };

    const dateIdx = _.indexOf(columns, "date");
    const idIdx = _.indexOf(columns, "ext_gam_unit_id");
    const groupIdx = _.indexOf(columns, "group_type");
    const reqIdx = _.indexOf(columns, "request_v2");

    _.values(TABS).forEach((tab) => {
      const tabIdx = _.indexOf(columns, tab);

      const grouped = _.groupBy(
        records,
        (item) =>
          `${item[dateIdx]}|${item[idIdx]}|${item[groupIdx]}|${item[tabIdx]}`
      );

      const result = _.map(grouped, (group) => {
        const [firstItem] = group;
        const sum = _.sumBy(group, (item) => item[reqIdx]);
        return [
          firstItem[dateIdx],
          firstItem[idIdx],
          firstItem[groupIdx],
          firstItem[tabIdx],
          sum,
        ];
      });

      const indexMap = new Map();

      _.forEach(result, (item) => {
        const date = item[0];
        const id = item[1];
        const group = item[2];
        const tabVal = item[3];
        const req = item[4];

        let index = indexMap.get(`${date}|${id}|${tabVal}`);

        if (index === undefined) {
          tabsObj[tab].records.push([date, id, tabVal, 0, 0, 0, 0]);
          hideUmObj[tab].records.push([date, id, tabVal, 0, 0, 0]);
          index = tabsObj[tab].records.length - 1;
          indexMap.set(`${date}|${id}|${tabVal}`, index);
        }

        if (group === "b") {
          tabsObj[tab].records[index][3] += req;
          hideUmObj[tab].records[index][3] += req;
        } else if (group === "o") {
          tabsObj[tab].records[index][4] += req;
          hideUmObj[tab].records[index][4] += req;
        } else if (group === "um") {
          tabsObj[tab].records[index][5] += req;
        }
        tabsObj[tab].records[index][6] += req;
        if (group !== "um") hideUmObj[tab].records[index][5] += req;
      });

      tabsObj[tab].columns[2] = tab;
      tabsObj[tab].arrangeColumns[2].key = tab;
      tabsObj[tab].arrangeColumns[2].label = _.startCase(
        tab.split("_").slice(0, 2).join(" ")
      );
      tabsObj[tab].tags = [
        {
          value: tabsObj[tab].arrangeColumns[2].key,
          label: tabsObj[tab].arrangeColumns[2].label,
          type: "string",
        },
        ...tabsObj[tab].tags,
      ];

      tabsObj[tab].result = parseTableData({
        columns: tabsObj[tab].columns,
        arrangeColumns: tabsObj[tab].arrangeColumns,
        records: tabsObj[tab].records,
        mainKey: "ext_gam_unit_id",
        subKey: "date",
        orderKey: "total_request",
      });

      hideUmObj[tab].columns[2] = tab;
      hideUmObj[tab].arrangeColumns[2].key = tab;
      hideUmObj[tab].arrangeColumns[2].label = _.startCase(
        tab.split("_").slice(0, 2).join(" ")
      );
      hideUmObj[tab].tags = [
        {
          value: hideUmObj[tab].arrangeColumns[2].key,
          label: hideUmObj[tab].arrangeColumns[2].label,
          type: "string",
        },
        ...hideUmObj[tab].tags,
      ];

      hideUmObj[tab].result = parseTableData({
        columns: hideUmObj[tab].columns,
        arrangeColumns: hideUmObj[tab].arrangeColumns,
        records: hideUmObj[tab].records,
        mainKey: "ext_gam_unit_id",
        subKey: "date",
        orderKey: "total_request",
      });
    });

    this.setState(
      {
        tabsObj,
        hideUmObj,

        alias: [
          {
            value:
              "total_request >= 10000 AND ( o_request_percent <= 0.88 OR o_request_percent >= 0.92)",
            label: "Quick Filter",
          },
          {
            func: (inputValue) =>
              `total_request >= 10000 AND ( o_request_percent <= ${(
                inputValue - 0.02
              ).toFixed(2)} OR o_request_percent >= ${(
                inputValue + 0.02
              ).toFixed(2)})`,
            label: "Custom O Request %",
          },
        ],
      },
      () => {
        this.handleSearch();
      }
    );
  }

  // Cause isHideUm flag need to exec filter data first
  handleSearch(expression = this.state.expression) {
    const { tabsObj, hideUmObj, isHideUm, selectedTab } = this.state;
    const {
      result: { records },
      arrangeColumns,
    } = isHideUm ? hideUmObj[selectedTab] : tabsObj[selectedTab];

    const result = filterDataToGroup({
      expression,
      records,
      columns: arrangeColumns,
      hasSubGroup: true,
    });

    if (result) {
      this.setState({
        expression,
        ...result,
      });
    }
  }

  render() {
    const {
      hideUmObj,
      tabsObj,
      selectedTab,
      isHideUm,
      alias,
      filterAmount,
      filterGroups,
      filterRecords,
    } = this.state;

    const dataObj = isHideUm ? hideUmObj : tabsObj;

    if (_.keys(dataObj).length === 0) {
      return null;
    }

    const { arrangeColumns, tags } = dataObj[selectedTab];

    const header = isHideUm ? (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={6}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
      </tr>
    ) : (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={6}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          um
        </th>
      </tr>
    );

    return (
      <>
        <div className="mb-2 flex w-full items-end justify-start gap-2">
          {_.values(TABS).map((tab) => (
            <button
              type="button"
              className={selectedTab === tab ? selectedButton : baseButton}
              style={{ width: "calc(16.66% - (0.5rem * 5) / 6)" }}
              key={tab}
              onClick={() =>
                this.setState({ selectedTab: tab }, () => {
                  this.handleSearch();
                })
              }
            >
              {_.startCase(tab.split("_").slice(0, 2).join(" "))}
            </button>
          ))}
          <div className="ml-auto flex items-center gap-1">
            <Checkbox
              isChecked={isHideUm}
              onChange={(value) =>
                this.setState({ isHideUm: value }, () => {
                  this.handleSearch();
                })
              }
            ></Checkbox>
            <span className="text-sm font-semibold text-gray-600 hover:text-gray-700">
              Hide um
            </span>
          </div>
        </div>

        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>

        <GroupDataTable
          header={header}
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="ext_gam_unit_id"
          subKey="date"
          columns={arrangeColumns}
        ></GroupDataTable>
      </>
    );
  }
}

export default GeneralRequestView;
